<template>
  <div class="bottom-navigation">
    <div class="nav-blur"></div>
    
    <div class="nav-content">
      <router-link to="/reward" class="nav-tab" active-class="active">
        <div class="nav-icon-container">
          <img src="../assets/images/ai/tabbar/tab-reward.png" class="nav-icon-img" alt="reward" />
        </div>
        <span class="nav-text">ของรางวัล</span>
        <div class="active-dot"></div>
      </router-link>

      <router-link to="/deposit" class="nav-tab deposit-tab" active-class="active">
        <div class="nav-icon-container">
          <img src="../assets/images/ai/tabbar/tab-deposit.png" class="nav-icon-img" alt="deposit" />
        </div>
        <span class="nav-text">แจ้งฝาก</span>
        <div class="active-dot"></div>
      </router-link>

      <router-link to="/withdraw" class="nav-tab withdraw-tab" active-class="active">
        <div class="nav-icon-container">
          <img src="../assets/images/ai/tabbar/tab-withdraw.png" class="nav-icon-img" alt="withdraw" />
        </div>
        <span class="nav-text">แจ้งถอน</span>
        <div class="active-dot"></div>
      </router-link>

      <router-link to="/history" class="nav-tab" active-class="active">
        <div class="nav-icon-container">
          <img src="../assets/images/ai/tabbar/tab-history.png" class="nav-icon-img" alt="history" />
        </div>
        <span class="nav-text">ประวัติ</span>
        <div class="active-dot"></div>
      </router-link>
    </div>

    <!-- Floating Active Indicator -->
    <div class="floating-indicator"></div>
  </div>
</template>

<script>
export default {
  name: 'BottomMenu',
  mounted() {
    this.updateActiveIndicator();
    // Listen for route changes
    this.$router.afterEach(() => {
      this.$nextTick(() => {
        this.updateActiveIndicator();
      });
    });
  },
  methods: {
    updateActiveIndicator() {
      const activeTab = document.querySelector('.nav-tab.active');
      const indicator = document.querySelector('.floating-indicator');
      
      if (activeTab && indicator) {
        const tabRect = activeTab.getBoundingClientRect();
        const navRect = document.querySelector('.nav-content').getBoundingClientRect();
        const position = tabRect.left - navRect.left + (tabRect.width / 2);
        
        indicator.style.transform = `translateX(${position}px)`;
        indicator.style.opacity = '1';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bottom-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 0.5px solid rgba(255, 255, 255, 0.1);
  
  // Safe area for modern phones
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.nav-blur {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(26, 26, 26, 0.98) 0%,
    rgba(20, 20, 20, 0.95) 100%
  );
  border-radius: 0;
}

.nav-content {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 86px;
  padding: 4px 8px;
}

.nav-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  padding: 8px 4px;
  border-radius: 16px;
  
  &:active {
    transform: scale(0.92);
  }
}

.nav-icon-container {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: transparent;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  margin-bottom: 2px;
  overflow: visible;       // allow icon-img to overflow container
}

.nav-icon {
  font-size: 26px !important;
  color: inherit;
  transition: all 0.3s ease;
}

// AI-gen chibi icons replace Material Icons (larger than container — overflow visible)
.nav-icon-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: grayscale(25%) brightness(0.9);
  transition: filter 0.3s ease, transform 0.3s ease;
}

.nav-text {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: rgba(255, 165, 100, 0.65);
  transition: all 0.3s ease;
  text-align: center;
  line-height: 1.1;
  font-family: 'Mali', 'Athiti', sans-serif;
}

.active-dot {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%) scale(0);
  width: 4px;
  height: 4px;
  background: #FF6B35;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

// Active state
.nav-tab.active {
  color: #ffffff;
  
  .nav-icon-container {
    background: linear-gradient(135deg, 
      rgba(45, 45, 45, 0.8) 0%, 
      rgba(35, 35, 35, 0.6) 100%
    );
    border: 1px solid rgba(255, 107, 53, 0.4);
    box-shadow: 
      0 8px 32px rgba(255, 107, 53, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
  
  .nav-icon {
    color: #FF6B35 !important;
    text-shadow: 0 0 20px rgba(255, 107, 53, 0.6);
  }

  .nav-icon-img {
    filter: grayscale(0%) brightness(1.1) drop-shadow(0 0 8px rgba(255, 107, 53, 0.7));
    transform: scale(1.1) translateY(-2px);
  }

  .nav-text {
    color: #FF6B35;
    font-weight: 700;
    text-shadow: 0 0 8px rgba(255, 107, 53, 0.4);
  }
  
  .active-dot {
    transform: translateX(-50%) scale(1);
    background: linear-gradient(45deg, #FF6B35, #FF9165);
    box-shadow: 0 0 10px rgba(255, 107, 53, 0.8);
  }
}

// Special styling for deposit tab
.deposit-tab {
  &.active {
    .nav-icon-container {
      background: linear-gradient(135deg, 
        rgba(45, 45, 45, 0.8) 0%, 
        rgba(35, 35, 35, 0.6) 100%
      );
      border: 1px solid rgba(76, 175, 80, 0.4);
      box-shadow: 
        0 8px 32px rgba(76, 175, 80, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
    
    .nav-icon {
      color: #4caf50 !important;
      text-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
    }
    
    .nav-text {
      color: #FF6B35;
    }
    
    .active-dot {
      background: linear-gradient(45deg, #FF6B35, #FF9165);
      box-shadow: 0 0 10px rgba(255, 107, 53, 0.8);
    }
  }
}

// Special styling for withdraw tab
.withdraw-tab {
  &.active {
    .nav-icon-container {
      background: linear-gradient(135deg, 
        rgba(45, 45, 45, 0.8) 0%, 
        rgba(35, 35, 35, 0.6) 100%
      );
      border: 1px solid rgba(244, 67, 54, 0.4);
      box-shadow: 
        0 8px 32px rgba(244, 67, 54, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
    
    .nav-icon {
      color: #f44336 !important;
      text-shadow: 0 0 20px rgba(244, 67, 54, 0.6);
    }
    
    .nav-text {
      color: #FF6B35;
    }
    
    .active-dot {
      background: linear-gradient(45deg, #FF6B35, #FF9165);
      box-shadow: 0 0 10px rgba(255, 107, 53, 0.8);
    }
  }
}

// Floating indicator
.floating-indicator {
  position: absolute;
  top: -3px;
  left: 0;
  width: 30px;
  height: 3px;
  background: linear-gradient(90deg, 
    transparent 0%,
    #FF6B35 20%,
    #FF9165 50%,
    #FF6B35 80%,
    transparent 100%
  );
  border-radius: 0 0 2px 2px;
  transform: translateX(0);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  opacity: 0;
  box-shadow: 0 4px 20px rgba(255, 107, 53, 0.4);
}

// Hover effects for desktop
@media (hover: hover) and (pointer: fine) {
  .nav-tab:not(.active):hover {
    color: rgba(255, 255, 255, 0.8);
    
    .nav-icon-container {
      background: rgba(255, 255, 255, 0.08);
      transform: translateY(-2px);
    }
    
    .nav-icon {
      color: rgba(255, 107, 53, 0.8) !important;
    }
  }
}

// Responsive adjustments
@media (max-width: 375px) {
  .nav-content {
    height: 65px;
    padding: 0 4px;
  }
  
  .nav-icon-container {
    width: 40px;
    height: 40px;
  }
  
  .nav-icon {
    font-size: 24px !important;
  }
  
  .nav-text {
    font-size: 9px;
  }
}

@media (max-width: 320px) {
  .nav-text {
    font-size: 8px;
  }
  
  .nav-icon-container {
    width: 36px;
    height: 36px;
  }
  
  .nav-icon {
    font-size: 22px !important;
  }
}

// Large screen adjustments
@media (min-width: 768px) {
  .bottom-navigation {
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 20px 20px 0 0;
    border-left: 0.5px solid rgba(255, 255, 255, 0.1);
    border-right: 0.5px solid rgba(255, 255, 255, 0.1);
  }
}

// Add subtle animation to icons
.nav-icon {
  animation: subtle-float 4s ease-in-out infinite;
}

.nav-tab:nth-child(2) .nav-icon { animation-delay: 0.5s; }
.nav-tab:nth-child(3) .nav-icon { animation-delay: 1s; }
.nav-tab:nth-child(4) .nav-icon { animation-delay: 1.5s; }

@keyframes subtle-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-1px); }
}

// Reduce motion for users who prefer it
@media (prefers-reduced-motion: reduce) {
  * {
    animation: none !important;
    transition-duration: 0.01ms !important;
  }
}
</style>

<style>
/* Global adjustments for the new bottom menu */
body {
  padding-bottom: 70px;
}

@supports (padding-bottom: env(safe-area-inset-bottom)) {
  body {
    padding-bottom: calc(70px + env(safe-area-inset-bottom, 0));
  }
}

/* Ensure content doesn't overlap */
.deposit-container,
.withdraw-container {
  padding-bottom: 80px !important;
}
</style>